export function truncateDecimals(value: string | number, decimals: number) {
  const valueString = value.toString()

  if (valueString.includes('.')) {
    const [integerValues, rest] = valueString.split('.', 2)
    return integerValues + '.' + rest.slice(0, decimals)
  }

  return valueString
}
